import React from "react";
import { FilterButtonProps } from "../../types/reminderTypes";
import styles from "./FilterButton.module.scss";

const FilterButton: React.FC<FilterButtonProps> = ({
  label,
  value,
  hasFilter,
  isActive = false,
  isVisible,
  onClick,
  className = "",
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      className={`
        ${styles.filterButton} 
        ${hasFilter ? styles.hasFilter : ""} 
        ${isActive ? styles.active : ""} 
        ${className}
      `}
      title={`${label}: ${value}`}
      type="button"
    >
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
      {hasFilter && <span className={styles.indicator}>•</span>}
    </button>
  );
};

export default FilterButton;
